import { styled } from '@mui/material';
import { EmptyMirror } from './icons/empty-mirror';

const StyledVideoPlaceholder = styled('div')(
  {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.dark,
  }),
);

export const VideoPlaceholder = (props) => (
  <StyledVideoPlaceholder {...props} style={{ position: 'relative', padding: 0, margin: 0 }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', padding: 0, margin: 0 }}>
        <EmptyMirror style={{ width: '100%', height: '100%', display: 'block', padding: 0, margin: 0 }} />
      </div>
  </StyledVideoPlaceholder>
);

export const HiddenVideoPlaceholder = styled('div')(({theme, shrinkedHeight}) => ({
    minWidth: `${shrinkedHeight ? 0 : 1}!important`,
    width: `${shrinkedHeight ? 0 : 1}!important`,
    minHeight: `${shrinkedHeight ? 0 : 48}!important`,
    height: `${shrinkedHeight ? 0 : 'inherit'}!important`,
    marginBottom: shrinkedHeight ? '8px!important' : 0,
    zIndex: -10,
    backgroundColor: theme.palette.novotalk.white,
}))